namespace GeniuzPOS.AdvPromo {
    export enum listfg {
        list0 = 0,
        list1 = 1,
        list2 = 2
    }
    Serenity.Decorators.registerEnumType(listfg, 'GeniuzPOS.AdvPromo.listfg');
}
